import React, { useState } from 'react';
import Problema from '../../../../assets/images/question.png';
import Sinal from '../../../../assets/images/Cobertura-WiFi-1.png';
import Card from 'react-bootstrap/Card';

import 'bootstrap/dist/css/bootstrap.min.css';

function Planejamento() {


  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Solução de problemas - Planejamento</h1>
            <img src={Problema} alt='problema' className='img-fluid mb-0' />
            <Card className="text-center">
              <Card.Header><div className="opcoes">Coleta de Informações e Análise do Ambiente</div></Card.Header>
              <Card.Body>
                {/* <Card.Title></Card.Title> */}
                <Card.Text>
                  <div className='opcoes'>
                  <div className="opcoes">
                    <strong>1. </strong>  Planejamento adequado do layout da rede,
                    incluindo a colocação estratégica de roteadores e pontos de acesso, é essencial. 
                    </div>
                    <div className="opcoes">
                    <strong>2. </strong>  Ferramentas de análise de Wi-Fi, como NetSpot e WiFi Analyzer, ajudam a
                    identificar pontos de interferência e zonas mortas,
                    permitindo ajustes para melhorar a cobertura e reduzir a interferência

                    </div>
                    <div className="opcoes">
                    <strong>3. </strong> Colete informações sobre a real necessidade do cliente, a quantidade de equipamentos ele possui, 
                    considere o tipo de aplicação que costuma e pretende utilizar, bem como futuras ampliações. 
                    </div>
                  </div>
                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer className="text-muted"><div className="opcoes">
              Registre todas as informações para uma análise detalhada do cenário e das necessidades do cliente.</div>
              </Card.Footer>
            </Card>

          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Sinal} alt="Current slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Planejamento;
